import { NgModule } from '@angular/core';
import { MetricEditComponent } from './metric-edit/metric-edit.component';
import { MetricListComponent } from './metric-list/metric-list.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    MetricEditComponent,
    MetricListComponent
  ],
})
export class MetricModule { }
